// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__2Zjqt","ScrollX":"Scroll_ScrollX__CN3kg","ScrollY":"Scroll_ScrollY__1-lWf"};